// import { Scope } from './lib/Scope';
import { Scope2 } from './lib/Scope2';

export * from './lib/components';
export * from './lib/hooks';
// export default Scope;
export default Scope2;
